
    <template v-slot:top>
  <v-card id="card">
    <!-- Overlay -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-toolbar dense class="white--text" color="indigo">
      <v-toolbar-title>Calendario Eventi</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="goToListaEventi" small v-bind="attrs" v-on="on"
            ><v-icon color="primary">mdi-calendar</v-icon></v-btn
          >
        </template>
        <span>Lista Eventi</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="goBack()" small v-bind="attrs" v-on="on"
            ><v-icon color="error">mdi-keyboard-backspace</v-icon></v-btn
          >
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>
    <v-container fluid>
      <div
        v-if="show_x_t"
        id="x_t"
        :style="{
          width: '100%',
          position: 'absolute',
          userSelect: 'none',
          backgroundColor: getEventColor(dragEvent ? dragEvent : createEvent),
          borderRadius: '22px',
          height: 2 + 'px',
          zIndex: 1,
          pointerEvents: 'none',
        }"
      ></div>
      <div
        v-if="show_y_l"
        id="y_l"
        :style="{
          width: 2 + 'px',
          backgroundColor: getEventColor(dragEvent),
          height: '100%',
          zIndex: 1,
          position: 'absolute',
          pointerEvents: 'none',
        }"
      ></div>
      <div
        v-if="show_x_b"
        id="x_b"
        :style="{
          width: '100%',
          position: 'absolute',
          userSelect: 'none',
          backgroundColor: getEventColor(dragEvent),
          height: 2 + 'px',
          zIndex: 1,
          pointerEvents: 'none',
        }"
      ></div>
      <div
        v-if="show_y_r"
        id="y_r"
        :style="{
          width: 2 + 'px',
          position: 'absolute',
          userSelect: 'none',
          backgroundColor: getEventColor(dragEvent),
          height: '100%',
          zIndex: 1,
          pointerEvents: 'none',
        }"
      ></div>
      <div>
        <v-snackbar :color="colore_snack" v-model="snackbar">
          {{ this.messaggio_snackbar }}
          <v-btn color="white" text @click="snackbar = false">Chiudi</v-btn>
        </v-snackbar>
        <v-form>
          <v-container fluid>
            <v-row class="fill-height">
              <v-col>
                <v-sheet height="64">
                  <v-toolbar flat color="white">
                    <v-btn
                      class="mr-4 white--text"
                      color="success"
                      @click="setToday"
                      >Vai a Oggi</v-btn
                    >
                    <v-btn fab text small color="indigo" @click="prev">
                      <v-icon medium>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-btn fab text small color="indigo" @click="next">
                      <v-icon medium>mdi-chevron-right</v-icon>
                    </v-btn>
                    <v-toolbar-title v-if="$refs.calendar">{{
                      $refs.calendar.title.charAt(0).toUpperCase() +
                      $refs.calendar.title.slice(1)
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-card class="mr-5" style="font-size: 20px" flat>
                      Vista :
                    </v-card>
                    <v-menu bottom right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="indigo"
                          class="white--text"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <span>{{ typeToLabel[type] }}</span>
                          <v-icon right> mdi-menu-down </v-icon>
                        </v-btn>
                      </template>
                      <v-list rounded outlined dense>
                        <v-list-item @click="type = 'day'">
                          <v-list-item-title>Giornaliera</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="type = 'week'">
                          <v-list-item-title>Settimanale</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="type = 'month'">
                          <v-list-item-title>Mensile</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="1000px" persistent>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="indigo"
                          dark
                          class="mb-2"
                          v-on="on"
                          @click="add = true"
                          >Nuovo evento</v-btn
                        >
                      </template>
                      <v-card>
                        <v-toolbar dense class="white--text" color="indigo">
                          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="clickChiudiDialogEvent()"
                                small
                                v-bind="attrs"
                                v-on="on"
                                ><v-icon color="error">mdi-close</v-icon></v-btn
                              >
                            </template>
                            <span>Indietro</span>
                          </v-tooltip>
                        </v-toolbar>
                        <v-card-text>
                          <v-container>
                            <v-row justify="center" align="center">
                              <v-col cols="4">
                                <v-text-field
                                  v-model="editedItem.titolo"
                                  label="Titolo"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="4">
                                <v-autocomplete
                                  dense
                                  hide-details
                                  label="Tipologia"
                                  :items="tipologia_lista"
                                  item-text="des"
                                  item-value="id_tabella"
                                  placeholder="Seleziona"
                                  required
                                  v-model="editedItem.tipologia"
                                >
                                  <template #label>
                                    <span class="">Tipologia</span>
                                    <a @click.stop style="pointer-events: all">
                                      <Modules
                                        v-on:dialogModules="gettabelle"
                                        tipo="MAN_TIPOLOGIA_EVENTO"
                                        nome="Tipologia"
                                        setaction="settabella"
                                        getaction="gettabella"
                                        controller="Global"
                                        :controllaCodice="true"
                                        :filter="'validita = 1'"
                                        :dati="[{ des: '' }]"
                                      />
                                    </a>
                                  </template>
                                </v-autocomplete>
                                <!-- <v-text-field
                                  v-model="editedItem.tipologia"
                                  label="Tipologia"
                                ></v-text-field> -->
                              </v-col>
                              <v-col cols="4">
                                <v-text-field
                                  v-model="editedItem.risorsa"
                                  label="Risorsa"
                                ></v-text-field>
                              </v-col>
                            </v-row>

                            <v-row align="center" justify="center">
                              <v-col cols="3">
                                <v-menu
                                  v-model="date_da"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="editedItem.data_inizio"
                                      label="Seleziona data inizio"
                                      prepend-inner-icon="event"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      color="primary"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    color="primary"
                                    header-color="primary"
                                    locale="it-it"
                                    v-model="editedItem.data_inizio"
                                    @input="date_da = false"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>

                              <v-col cols="2">
                                <v-text-field
                                  v-model="editedItem.ora_inizio"
                                  label="Ora inizio"
                                  prepend-inner-icon="watch"
                                  readonly
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                              <!-- MENU PULSANTE ORA INIZIO -->
                              <v-col cols="1">
                                <v-menu
                                  v-model="time_da"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn small v-bind="attrs" v-on="on"
                                      ><v-icon color="primary"
                                        >mdi-clock</v-icon
                                      ></v-btn
                                    >
                                  </template>
                                  <v-time-picker
                                    v-model="editedItem.ora_inizio"
                                    :landscape="$vuetify.breakpoint.smAndUp"
                                    format="24hr"
                                    scrollable
                                  ></v-time-picker>
                                </v-menu>
                              </v-col>

                              <v-col cols="3">
                                <v-menu
                                  v-model="date_a"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="editedItem.data_fine"
                                      label="Seleziona data fine"
                                      prepend-inner-icon="event"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      color="primary"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    color="primary"
                                    header-color="primary"
                                    locale="it-it"
                                    v-model="editedItem.data_fine"
                                    @input="date_a = false"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="2">
                                <v-text-field
                                  v-model="editedItem.ora_fine"
                                  label="Ora fine"
                                  prepend-inner-icon="watch"
                                  readonly
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="1">
                                <!-- MENU PULSANTE ORA FINE-->
                                <v-menu
                                  v-model="time_a"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn small v-bind="attrs" v-on="on"
                                      ><v-icon color="primary"
                                        >mdi-clock</v-icon
                                      ></v-btn
                                    >
                                  </template>
                                  <v-time-picker
                                    v-model="editedItem.ora_fine"
                                    :landscape="$vuetify.breakpoint.smAndUp"
                                    format="24hr"
                                    scrollable
                                  ></v-time-picker>
                                </v-menu>
                              </v-col>

                              <!-- NOTE SECTION -->
                              <v-col cols="12">
                                <v-textarea
                                  outlined
                                  name="input-7-4"
                                  label="Note"
                                  v-model="editedItem.note"
                                ></v-textarea>
                              </v-col>

                              <!-- COLORE SECCTION -->
                              <!--<v-col cols="6" sm="6" md="6">
                                <v-color-picker
                                  v-model="editedItem.colore_evento"
                                  class="ma-2"
                                  show-swatches
                                  hide-canvas
                                  hide-inputs
                                  mode="hexa"
                                ></v-color-picker>
                              </v-col>-->
                            </v-row>
                          </v-container>
                        </v-card-text>

                        <v-card-actions v-if="add == false">
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="dialog = false"
                            >Cancella</v-btn
                          >
                          <v-btn color="blue darken-1" text @click="setEvento()"
                            >Salva</v-btn
                          >
                        </v-card-actions>
                        <v-card-actions v-else>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="dialog = false"
                            >Annulla</v-btn
                          >
                          <v-btn color="blue darken-1" text @click="setEvento()"
                            >Salva</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </v-sheet>
                <v-sheet height="600">
                  <v-calendar
                    ref="calendar"
                    v-model="focus"
                    color="primary"
                    :events="events"
                    :key="contatore"
                    :event-color="getEventColor"
                    :type="type"
                    :event-overlap-mode="mode"
                    :event-ripple="false"
                    :event-overlap-threshold="60"
                    :weekdays="weekday"
                    @change="getEvents"
                    @click:event="showEvent"
                    @click:more="viewDay"
                    @click:date="viewDay"
                    @mousedown:event="startDrag"
                    @mousedown:time="startTime"
                    @mousedown:day="startTimeDay"
                    @mousemove:time="mouseMove"
                    @mousemove:day="mouseMoveDay"
                    @mouseup:time="endDrag"
                    @mouseup:day="endDragDay"
                  >
                    <template #event="{ event, timed }">
                      <div class="noselect">
                        {{
                          timed && type === "day"
                            ? event.name != null
                              ? event.name
                              : "N/D" +
                                ": " +
                                event.ora_inizio.substr(0, 5) +
                                " - " +
                                event.ora_fine.substr(0, 5)
                            : timed
                            ? event.name != null
                              ? event.name
                              : "N/D" + ": " + event.ora_inizio.substr(0, 5)
                            : event.name != null
                            ? event.name
                            : "N/D" + ": " + event.ora_inizio.substr(0, 5)
                        }}
                      </div>
                      <div
                        class="extendBottom"
                        v-if="timed && event.id_evento_calendario != -99"
                      >
                        <v-icon
                          color="white"
                          class="extend_icon"
                          @mousedown.stop="extendBottom(event)"
                          >mdi-drag-horizontal-variant</v-icon
                        >
                      </div>
                    </template>
                    <template #day-body="{ date, week }">
                      <div
                        class="v-current-time"
                        :class="{ first: date === week[0].date }"
                        :style="{ top: nowY }"
                      >
                        <div class="v-current-time-time">
                          {{ nowTime }}
                        </div>
                      </div>
                    </template>
                    &nbsp;
                  </v-calendar>
                  <v-menu
                    v-model="selectedOpen"
                    :activator="selectedElement"
                    offset-x
                  >
                    <v-card
                      v-if="selectedEvent != null"
                      color="grey lighten-4"
                      min-width="350px"
                      flat
                    >
                      <v-toolbar :color="selectedEvent.color" dark>
                        <v-btn
                          v-if="selectedEvent.id == -99"
                          @click="
                            getInterventoDettaglio(selectedEvent), (add = false)
                          "
                          icon
                        >
                          <v-icon>{{ selectedEvent.icona }}</v-icon>
                        </v-btn>
                        <v-btn
                          v-else
                          @click="editItem(selectedEvent), (add = false)"
                          icon
                        >
                          <v-icon>{{ selectedEvent.icona }}</v-icon>
                        </v-btn>
                        <v-toolbar-title
                          v-html="
                            selectedEvent.titolo != null
                              ? selectedEvent.titolo
                              : 'N/D'
                          "
                        ></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                          icon
                          v-if="selectedEvent.id_evento_calendario != -99"
                          @click="deleteItem(selectedEvent)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-text>
                        <span>
                          <b>Data Schedulata:</b>
                          {{
                            new Date(
                              selectedEvent.data_inizio
                            ).toLocaleDateString("en-GB")
                          }}</span
                        >
                        <br />
                        <span>
                          <b>Ora Schedulata:</b>
                          {{ selectedEvent.ora_inizio }}</span
                        >
                        <br />
                        <span>
                          <b>Note:</b>
                          {{
                            selectedEvent.note != null
                              ? selectedEvent.note
                              : "N/D"
                          }}</span
                        >
                        <br />
                        <span>
                          <b>Fornitore:</b>
                          {{
                            selectedEvent.risorsa != null
                              ? selectedEvent.risorsa
                              : "N/D"
                          }}</span
                        >
                        <br />

                        <span v-if="selectedEvent.tipologia == 'INTERVENTO'">
                          <b>Marca:</b>
                          {{
                            selectedEvent.marca != null
                              ? selectedEvent.marca
                              : "N/D"
                          }}</span
                        >
                        <br />
                        <span v-if="selectedEvent.tipologia == 'INTERVENTO'">
                          <b>Modello:</b>
                          {{
                            selectedEvent.modello != null
                              ? selectedEvent.modello
                              : "N/D"
                          }}
                        </span>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn text color="secondary" @click="clickCloseMenu()">
                          Annulla
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-dialog v-model="dialog_elimina_evento" width="500">
          <v-card>
            <v-toolbar class="white--text" dense color="indigo">
              <v-toolbar-title> Attenzione! </v-toolbar-title>
            </v-toolbar>

            <v-card-text class="mt-4">
              Sei sicuro di voler eliminare l'evento selezionato?
            </v-card-text>

            <v-card-actions>
              <v-container>
                <v-row>
                  <v-spacer> </v-spacer>
                  <v-btn
                    dark
                    color="error"
                    style="margin-right: 10px"
                    @click="dialog_elimina_evento = false"
                    >annulla</v-btn
                  >
                  <v-btn dark color="success" @click="confermaEliminaEvento()"
                    >conferma</v-btn
                  >
                </v-row>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <div v-show="false">
          <Adapter
            @aggiornato_intervento="getEvents()"
            :calendar="true"
            ref="adapter"
          />
        </div>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import Adapter from "../../views/NAVALREPAIR/GestioneSintetica.vue";

class Event {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte i campi
  reset() {
    const campi = this.setControlli();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setControlli() {
    const campi = [
      { nome: "id_evento_calendario", default_val: -1 },
      { nome: "icona", default_val: "" },
      { nome: "tipologia", default_val: "" },
      { nome: "risorsa", default_val: "N/D" },
      { nome: "name", default_val: "" },
      { nome: "start", default_val: "" },
      { nome: "end", default_val: "" },
      { nome: "color", default_val: "" },
      { nome: "id_riferimento_evento", default_val: null },
      { nome: "colore_evento", default_val: "" },
      { nome: "icona", default_val: "" },
      { nome: "colore_icona", default_val: "" },
      { nome: "titolo", default_val: "" },
      { nome: "note", default_val: "" },
      { nome: "data_inizio", default_val: "" },
      { nome: "ora_inizio", default_val: "" },
      { nome: "ora_fine", default_val: "" },
      { nome: "data_fine", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];
    return campi;
  }
}

export default {
  components: {
    Adapter,
    Modules: () => import("@/components/TOOLS/Modules"),
  },
  data: () => ({
    snackbar: false,
    messaggio_snackbar: null,
    colore_snack: null,
    add: false,
    dialog_elimina_evento: false,
    date_da: false,
    date_a: false,
    time_da: false,
    time_a: false,
    focus: "",
    type: "month",
    selectedEvent: new Event(),
    selectedElement: null,
    selectedOpen: false,
    events: [],
    intervention: [],
    weekday: [1, 2, 3, 4, 5, 6, 0],
    tipologia_lista: [],
    contatore: 0,
    year: null,
    typeToLabel: {
      month: "Mensile",
      week: "Settimanale",
      day: "Giornaliera",
    },
    dialog: false,
    editedIndex: -1,
    editedItem: new Event(),
    mode: "stack",
    dragEvent: null,
    dragStart: null,
    lastEvent: "",
    createEvent: null,
    createStart: null,
    extendOriginal: null,
    from_drag: false,
    extend_bottom: false,
    start_time_bottom: false,
    x: null,
    y: null,
    x_event_l: null,
    x_event_r: null,
    y_event_t: null,
    y_event_b: null,
    show_x_t: false,
    show_x_b: false,
    show_y_l: false,
    show_y_r: false,
    div_oriz_offset: null,

    isMounted: false,
  }),

  computed: {
    nowY() {
      const cal = this.$refs.calendar;
      if (!cal && !this.isMounted) {
        return -1;
      }
      console.log(cal.$children[0].timeToY(cal.times.now));
      return cal.timeToY(cal.times.now) + "px";
    },
    nowTime() {
      const cal = this.$refs.calendar;
      if (!cal && !this.isMounted) {
        return -1;
      }
      console.log("nowTime", cal.formatTime(cal.times.now));
      return cal.formatTime(cal.times.now);
    },
    formTitle() {
      return this.editedItem.id_evento_calendario === -1
        ? "Nuovo Evento"
        : "Modifica Evento";
    },
    // computedDateFormatted() {
    //   return this.formatDate(this.date);
    // },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  mounted() {
    const cal = this.$refs.calendar;
    const minutes = cal.times.now.hour * 60 + cal.times.now.minute;
    const firstTime = Math.max(0, minutes - (minutes % 30) - 30);
    cal.scrollToTime(firstTime);
    setInterval(() => cal.updateTimes(), 60 * 1000);
    this.isMounted = true;
    this.gettabelle();
  },

  created() {
    this.getEvents();
  },

  methods: {
    clickChiudiDialogEvent() {
      this.editedItem = new Event();
      this.dialog = false;
    },
    clickCloseMenu() {
      this.selectedOpen = false;
      this.start_time_bottom = false;
      this.extend_bottom = false;
      this.dragTime = null;
      this.dragEvent = null;
      this.createEvent = null;
      this.createStart = null;
      this.extendOriginal = null;
      this.from_drag = false;
      this.dialog = false;
      this.selectedOpen = false;
    },
    goBack() {
      this.$router.push("/home/naval");
    },
    getInterventoDettaglio(item) {
      this.intervention.forEach((e) => {
        if (e.id_intervento == item.id_riferimento_evento) {
          // Formatto la data_schedulata come conviene al FE
          e.data_schedulata =
            e.data_schedulata != null && e.data_schedulata != ""
              ? e.data_schedulata.length > 10
                ? e.data_schedulata.substr(0, 10)
                : e.data_schedulata
              : "";

          // Apro la finestra di dialogo sull'intervento selezionato.
          this.$refs.adapter.$refs.tabella_richieste.clickModificaIntervento(e);
        }
      });
    },
    getEvents() {
      console.log("inizio get");
      this.overlay = true;
      let richiesta = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getcalendariointerventi",
          token: localStorage.user_token,
        },
      };
      this.$store.dispatch("api", richiesta).then((res) => {
        if (res.status === 200) {
          this.overlay = false;
          this.overlay = false;
          this.events = [];
          this.events = res.data.events.filter((e) => e.data_inizio != null);
          this.intervention = res.data.intervention;

          this.events.forEach((e) => {
            if (e.tipologia === "INTERVENTO") {
              e.id = e.id_evento_calendario;
              e.timed = true;
              e.start = new Date(e.data_inizio);
              e.end = new Date(e.data_inizio).setMinutes(
                new Date(e.data_inizio).getMinutes() + 15
              );
              e.name = e.titolo;
              e.color = e.colore_evento;
            } else {
              e.id = e.id_evento_calendario;
              e.timed = true;
              e.start = new Date(e.data_inizio);
              e.end = e.data_fine !== null ? new Date(e.data_fine) : null;
              e.name = e.titolo;
              e.color = e.colore_evento;
            }
          });

          // this.events.forEach((event) => {
          //   if (
          //     event.id_evento_calendario ==
          //     this.selectedEvent.id_evento_calendario
          //   ) {
          //     console.log("perche questo?");
          //     this.selectedEvent = new Event(event);
          //   }
          // });
        } else {
          console.log("error get");
          this.overlay = false;
          this.snackbar = true;
          this.messaggio_snackbar = "Nessun elemento trovato!";
          this.colore_snack = "orange";
        }
      });
    },
    gettabelle() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "MAN_TIPOLOGIA_EVENTO",
          filter: "validita = 1",
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.tipologia_lista = res.data ? res.data : [];
        }
      });
    },
    goToListaEventi() {
      this.$router.push("/home/naval/CalendarioEventiLista");
    },
    setEvento() {
      if (this.from_drag == true) {
        this.overlay = true;

        this.selectedEvent =
          this.from_drag === true
            ? this.selectedEvent
            : new Event(this.editedItem);
        this.selectedEvent.icona = "mdi-pencil";

        delete this.selectedEvent.name;
        delete this.selectedEvent.start;
        delete this.selectedEvent.end;

        this.dialog = false;
        console.log("setEento obj", this.selectedEvent);

        let richiesta = {
          controller: "Manutenzione",
          method: "PUT",
          richiesta: {
            action: "seteventocalendario",
            token: localStorage.user_token,
            tabella: [this.selectedEvent],
          },
        };

        this.$store.dispatch("api", richiesta).then((res) => {
          if (res.status == 200) {
            this.overlay = false;
            this.snackbar = true;
            this.messaggio_snackbar = "Evento salvato con successo";
            this.colore_snack = "success";
            this.getEvents();
            this.editedItem = new Event();
            this.selectedEvent = null;
            this.dialog = false;
            this.from_drag = false;
            this.extend_bottom = false;
            this.selectedOpen = false;
          } else {
            this.overlay = false;
            this.editedItem = new Event();
            this.selectedEvent = null;
            this.snackbar = true;
            this.from_drag = false;
            this.extend_bottom = false;
            this.selectedOpen = false;
            this.messaggio_snackbar = "Nessun elemento trovato!";
            this.colore_snack = "orange";
          }
        });
      } else if (
        this.editedItem.titolo == "" ||
        this.editedItem.titolo == null ||
        this.editedItem.data_inizio == "" ||
        this.editedItem.data_inizio == null ||
        this.editedItem.ora_inizio == "" ||
        this.editedItem.ora_inizio == null ||
        this.editedItem.data_fine == "" ||
        this.editedItem.data_fine == null ||
        this.editedItem.ora_fine == "" ||
        this.editedItem.ora_fine == null
      ) {
        this.snackbar = true;
        this.messaggio_snackbar = "ERRORE: COMPILARE TUTTI I CAMPI";
        this.colore_snack = "error";
        return;
      } else {
        this.overlay = true;
        // this.editedItem.color = this.editedItem.colore_evento;
        console.log("from drag", this.from_drag);
        console.log("obj valido", this.editedItem);
        // this.editedItem.titolo = this.editedItem.name;
        // this.editedItem.data_inizio = this.editedItem.start;
        // this.editedItem.data_fine = this.editedItem.end;

        this.selectedEvent =
          this.from_drag === true
            ? this.selectedEvent
            : new Event(this.editedItem);
        this.selectedEvent.icona = "mdi-pencil";

        delete this.selectedEvent.name;
        delete this.selectedEvent.start;
        delete this.selectedEvent.end;

        this.dialog = false;
        console.log("setEento obj", this.selectedEvent);

        let richiesta = {
          controller: "Manutenzione",
          method: "PUT",
          richiesta: {
            action: "seteventocalendario",
            token: localStorage.user_token,
            tabella: [this.selectedEvent],
          },
        };

        this.$store.dispatch("api", richiesta).then((res) => {
          if (res.status == 200) {
            console.log("fine set");
            this.overlay = false;
            this.snackbar = true;
            this.messaggio_snackbar = "Evento salvato con successo";
            this.colore_snack = "success";
            this.getEvents();
            this.editedItem = new Event();
            this.selectedEvent = null;
            this.dialog = false;
            this.from_drag = false;
            this.extend_bottom = false;
            this.selectedOpen = false;
          } else {
            this.overlay = false;
            this.editedItem = new Event();
            this.selectedEvent = null;
            this.snackbar = true;
            this.from_drag = false;
            this.extend_bottom = false;
            this.selectedOpen = false;
            this.messaggio_snackbar = "Nessun elemento trovato!";
            this.colore_snack = "orange";
          }
        });
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    goToMonth() {
      this.type = "month";
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen && this.selectedEvent.tipologia != "INTERVENTO") {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    editItem(item) {
      item.data_inizio = item.data_inizio.split("T")[0];
      item.data_fine = item.data_fine.split("T")[0];
      this.editedIndex = this.events.indexOf(item);
      this.editedItem = new Event(item);

      this.dialog = true;
    },
    deleteItem(item) {
      //const index = this.events.indexOf(item);
      this.dialog_elimina_evento = true;
      this.editedItem = item;
    },
    confermaEliminaEvento() {
      this.dialog_elimina_evento = false;
      this.editedItem.validita = 0;

      let richiesta = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          token: localStorage.user_token,
          action: "seteventocalendario",
          tabella: [this.editedItem],
        },
      };

      this.$store.dispatch("api", richiesta).then((res) => {
        if (res.status === 200) {
          this.snackbar = true;
          this.messaggio_snackbar = "Evento aggiornato con successo";
          this.colore_snack = "success";
          this.getEvents();
          this.editedItem = new Event();
        }
      });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = new Event();
        this.editedIndex = -1;
      }, 300);
    },
    getEventColor(event) {
      const rgb = parseInt(event.color.substring(1), 16);
      const r = (rgb >> 16) & 0xff;
      const g = (rgb >> 8) & 0xff;
      const b = (rgb >> 0) & 0xff;

      return event === this.dragEvent
        ? `rgba(${r}, ${g}, ${b}, 0.5)`
        : event === this.createEvent
        ? `rgba(${r}, ${g}, ${b}, 0.5)`
        : event.color;
    },
    extendBottom(event) {
      if (this.selectedOpen === true) {
        this.selectedOpen = false;
        return;
      }
      if (event != null) {
        this.show_x_t = true;
        this.extend_bottom = true;
        this.selectedOpen = false;
        this.createEvent = event;
        this.createStart = event.start.getTime();
        this.extendOriginal = event.end;
      }
    },
    toDate(tms) {
      return typeof tms === "string"
        ? new Date(tms)
        : new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute);
    },
    startDrag(e) {
      if (this.selectedOpen === true) {
        this.selectedOpen = false;
        return;
      }
      console.log("log e", e);

      const rect_r =
        e.nativeEvent.path[0].className == "v-event-timed white--text"
          ? e.nativeEvent.path[0].getBoundingClientRect()
          : e.nativeEvent.path[1].getBoundingClientRect();

      const someDiv = document.getElementById("card");
      const distanceToTop = someDiv.getBoundingClientRect().top;
      const distanceToLeft = someDiv.getBoundingClientRect().left;

      if (this.type === "week" || this.type === "month") {
        this.start_time_bottom = true;

        this.x_event_l = e.nativeEvent.clientX - rect_r.left + distanceToLeft;
        this.x_event_r = e.nativeEvent.clientX - rect_r.right + distanceToLeft;
        this.y_event_t = e.nativeEvent.clientY - rect_r.top + distanceToTop;
        this.y_event_b = e.nativeEvent.clientY - rect_r.bottom + distanceToTop;
      } else if (this.type === "day") {
        this.start_time_bottom = true;

        this.y_event_t = e.nativeEvent.clientY - rect_r.top + distanceToTop;

        this.y_event_b = e.nativeEvent.clientY - rect_r.bottom + distanceToTop;
      }

      if (e.event) {
        this.dragEvent = e.event;
        this.dragTime = null;
        this.extendOriginal = null;
      }

      this.lastEvent = "startDrag";
    },
    startTimeDay(e) {
      if (this.selectedOpen === true) {
        this.selectedOpen = false;
        return;
      }
      const mouse = this.toDate(e);
      if (this.dragEvent && this.dragTime === null) {
        const start = new Date(this.dragEvent.start);
        this.dragTime = mouse.getTime() - start.getTime();
      }
    },
    startTime(e) {
      if (this.selectedOpen === true) {
        this.selectedOpen = false;
        return;
      }
      const mouse = this.toDate(e);
      if (this.dragEvent && this.dragTime === null) {
        const start = new Date(this.dragEvent.start);
        this.dragTime = mouse.getTime() - start.getTime();
      } else if (this.extend_bottom == true) {
        this.createStart = this.roundTime(mouse.getTime());
        this.createEvent = this.dragEvent;
        this.createEvent.start = this.toTimestamp(new Date(this.createStart));
        this.createEvent.end = this.toTimestamp(new Date(this.createStart));

        // this.events.push(this.createEvent);
      }
      this.lastEvent = "startTime";
    },

    mouseMoveDay(e) {
      if (this.type === "month" && this.start_time_bottom === true) {
        console.log("move e", e);
        let that = this;
        document.onmousemove = function (event) {
          this.x = event.clientX;
          this.y = event.clientY;

          document.getElementById("x_t").style.top =
            this.y - that.y_event_t + "px";
          document.getElementById("x_b").style.top =
            this.y - that.y_event_b + "px";
          document.getElementById("y_r").style.left =
            this.x - that.x_event_r + "px";
          document.getElementById("y_l").style.left =
            this.x - that.x_event_l + "px";
        };
        this.show_x_t = true;
        this.show_x_b = true;
        this.show_y_l = true;
        this.show_y_r = true;
      }
      if (
        this.dragEvent &&
        this.dragTime != null &&
        this.start_time_bottom === true
      ) {
        // const start = this.dragEvent.start;
        // const end = this.dragEvent.end;
        const duration =
          new Date(this.dragEvent.end).getTime() -
          new Date(this.dragEvent.start).getTime();
        const mouse = this.toDate(e);

        const newStartTime = mouse.getTime() - this.dragTime;
        const newStart = new Date(this.roundTime(newStartTime));
        const newEnd = new Date(newStart.getTime() + duration);
        this.dragEvent.start = this.toTimestamp(newStart);
        this.dragEvent.end = this.toTimestamp(newEnd);
      }
    },
    mouseMove(e) {
      if (this.extend_bottom === true || this.start_time_bottom === true) {
        console.log("move e", e);
        if (
          this.type === "week" ||
          (this.type === "month" && this.start_time_bottom === true)
        ) {
          let that = this;
          document.onmousemove = function (event) {
            this.x = event.clientX;
            this.y = event.clientY;

            document.getElementById("x_t").style.top =
              this.y - that.y_event_t + "px";
            document.getElementById("x_b").style.top =
              this.y - that.y_event_b + "px";
            document.getElementById("y_r").style.left =
              this.x - that.x_event_r + "px";
            document.getElementById("y_l").style.left =
              this.x - that.x_event_l + "px";
          };
          this.show_x_t = true;
          this.show_x_b = true;
          this.show_y_l = true;
          this.show_y_r = true;
        } else if (this.type === "day" && this.start_time_bottom === true) {
          let that = this;
          document.onmousemove = function (event) {
            this.x = event.clientX;
            this.y = event.clientY;

            document.getElementById("x_t").style.top =
              this.y - that.y_event_t + "px";
            document.getElementById("x_b").style.top =
              this.y - that.y_event_b + "px";
          };
          this.show_x_t = true;
          this.show_x_b = true;
        }

        if (this.dragEvent && this.dragTime != null) {
          // const start = this.dragEvent.start;
          // const end = this.dragEvent.end;
          const duration =
            new Date(this.dragEvent.end).getTime() -
            new Date(this.dragEvent.start).getTime();
          const mouse = this.toDate(e);

          const newStartTime = mouse.getTime() - this.dragTime;
          const newStart = new Date(this.roundTime(newStartTime));
          const newEnd = new Date(newStart.getTime() + duration);
          this.dragEvent.start = this.toTimestamp(newStart);
          this.dragEvent.end = this.toTimestamp(newEnd);
        } else if (this.createEvent && this.createStart !== null) {
          if (this.show_x_t === true && this.extend_bottom === true) {
            document.onmousemove = function (e) {
              const someDiv = document.getElementById("card");
              const distanceToTop = someDiv.getBoundingClientRect().top;
              this.x = e.clientX;
              this.y = e.clientY;

              if (document.getElementById("x_t") != null) {
                document.getElementById("x_t").style.top =
                  this.y - distanceToTop + 4 + "px";
              }
            };
          }
          const mouse = this.toDate(e).getTime();
          const mouseRounded = this.roundTime(mouse, false);
          const min = Math.min(mouseRounded, this.createStart);
          const max = Math.max(mouseRounded, this.createStart);

          this.createEvent.start = this.toTimestamp(new Date(min));
          this.createEvent.end = this.toTimestamp(new Date(max));
        }
      }
    },
    endDragDay() {
      console.log("end drag");
      document.onmousemove = null;

      this.show_x_t = false;
      this.show_x_b = false;
      this.show_y_l = false;
      this.show_y_r = false;

      if (this.dragEvent != null && this.start_time_bottom === true) {
        this.start_time_bottom = false;
        if (
          this.dragEvent.tipologia == "INTERVENTO" ||
          this.dragEvent.id_evento_calendario == -99
        ) {
          let intervento_tmp = {};

          intervento_tmp.id_intervento = this.dragEvent.id_riferimento_evento;
          intervento_tmp.data_schedulata = this.dragEvent.start.split(" ")[0];
          intervento_tmp.ora_schedulata = this.dragEvent.start.split(" ")[1];

          this.setInterventoEvento(intervento_tmp);

          intervento_tmp = {};

          this.editedItem = new Event();
          this.dragTime = null;
          this.dragEvent = null;
          this.createEvent = null;
          this.createStart = null;
          this.extendOriginal = null;
          this.from_drag = false;
          this.dialog = false;
          this.selectedOpen = false;
          this.extend_bottom = false;

          return;
        }
        this.selectedEvent = new Event(this.dragEvent);
        this.selectedEvent.ora_inizio = this.selectedEvent.start.split(" ")[1];
        this.selectedEvent.ora_fine = this.selectedEvent.end.split(" ")[1];
        this.selectedEvent.data_inizio = this.selectedEvent.start.split(" ")[0];
        this.selectedEvent.data_fine = this.selectedEvent.end.split(" ")[0];

        this.dragTime = null;
        this.dragEvent = null;
        this.createEvent = null;
        this.createStart = null;
        this.extendOriginal = null;
        this.from_drag = true;
        this.dialog = false;
        this.selectedOpen = false;
        this.editedItem = new Event();

        this.setEvento();
      }

      this.editedItem = new Event();

      this.dragTime = null;
      this.dragEvent = null;
      this.createEvent = null;
      this.createStart = null;
      this.extendOriginal = null;

      this.from_drag = false;
      this.dialog = false;
      this.selectedOpen = false;

      this.lastEvent = "endDrag";
    },
    endDrag() {
      document.onmousemove = null;
      console.log("end drag");

      this.show_x_t = false;
      this.show_x_b = false;
      this.show_y_l = false;
      this.show_y_r = false;

      if (this.extend_bottom === true || this.start_time_bottom === true) {
        this.start_time_bottom = false;
        this.extend_bottom = false;
        if (this.dragEvent != null) {
          if (
            this.dragEvent.tipologia == "INTERVENTO" ||
            this.dragEvent.id_evento_calendario == -99
          ) {
            let intervento_tmp = {};

            intervento_tmp.id_intervento = this.dragEvent.id_riferimento_evento;
            intervento_tmp.data_schedulata = this.dragEvent.start.split(" ")[0];
            intervento_tmp.ora_schedulata = this.dragEvent.start.split(" ")[1];

            this.setInterventoEvento(intervento_tmp);

            intervento_tmp = {};

            this.dragTime = null;
            this.dragEvent = null;
            this.createEvent = null;
            this.createStart = null;
            this.extendOriginal = null;
            this.from_drag = false;
            this.dialog = false;
            this.selectedOpen = false;

            return;
          }
          this.selectedEvent = new Event(this.dragEvent);
          this.selectedEvent.ora_inizio =
            this.selectedEvent.start.split(" ")[1];
          this.selectedEvent.ora_fine = this.selectedEvent.end.split(" ")[1];
          this.selectedEvent.data_inizio =
            this.selectedEvent.start.split(" ")[0];
          this.selectedEvent.data_fine = this.selectedEvent.end.split(" ")[0];
        } else if (this.createEvent != null) {
          this.selectedEvent = new Event(this.createEvent);
          this.selectedEvent.ora_inizio =
            this.selectedEvent.start.split(" ")[1];
          this.selectedEvent.ora_fine = this.selectedEvent.end.split(" ")[1];
          this.selectedEvent.data_inizio =
            this.selectedEvent.start.split(" ")[0];
          this.selectedEvent.data_fine = this.selectedEvent.end.split(" ")[0];
        }

        this.dragTime = null;
        this.dragEvent = null;
        this.createEvent = null;
        this.createStart = null;
        this.extendOriginal = null;
        this.from_drag = true;
        this.dialog = false;
        this.selectedOpen = false;

        this.setEvento();
      }

      this.editedItem = new Event();

      this.dragTime = null;
      this.dragEvent = null;
      this.createEvent = null;
      this.createStart = null;
      this.extendOriginal = null;

      this.from_drag = false;
      this.dialog = false;
      this.selectedOpen = false;

      this.lastEvent = "endDrag";
    },
    // cancelDrag() {
    //   console.log("cancel");
    //   if (this.createEvent) {
    //     if (this.extendOriginal) {
    //       this.createEvent.end = this.extendOriginal;
    //     } else {
    //       const i = this.events.indexOf(this.createEvent);
    //       if (i !== -1) {
    //         this.events.splice(i, 1);
    //       }
    //     }
    //   }
    //   this.createEvent = null;
    //   this.createStart = null;
    //   this.dragTime = null;
    //   this.dragEvent = null;
    //   this.show_x_t = false;
    //   this.show_x_b = false;
    //   this.show_y_l = false;
    //   this.show_y_r = false;
    //   this.extend_bottom = false;
    //   this.start_time_bottom = false;

    //   this.lastEvent = "cancelDrag";
    // },
    roundTime(time, down = true) {
      const roundDownTime = 15 * 60 * 1000; // 15 minutes

      return down
        ? time - (time % roundDownTime)
        : time + (roundDownTime - (time % roundDownTime));
    },
    toTimestamp(date) {
      return `${date.getFullYear()}-${
        date.getMonth() + 1
      }-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`;
    },
    setInterventoEvento(arg) {
      this.overlay = true;
      let request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "seteventointervento",
          token: localStorage.user_token,
          intervento: [arg],
        },
      };

      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          if (res.status === 200) {
            console.log(res);
            this.overlay = false;
            this.getEvents();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Errore di comunicazione col server, non è stato possibile salvare i dati.`
            );
          }
        })
        .catch((err) => {
          if (err.response.status == 404) {
            this.$refs.SnackbarQV.print("error", `${err.response.data.result}`);
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              `Errore di comunicazione col server, non è stato possibile salvare i dati.`
            );
          }
        });
    },
  },
};
</script>
<style scoped>
.extendBottom {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  text-align: center;
}
.extend_icon {
  bottom: -12px;
}
.extend_icon:hover {
  cursor: row-resize;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.v-calendar {
  user-select: none;
  -webkit-user-select: none;
}
.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;
}
.v-event-drag-bottom::after {
  display: none;
  position: absolute;
  left: 50%;
  height: 4px;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  width: 20px;
  margin-left: -10px;
  opacity: 0.8;
  content: "";
}
.v-event-timed:hover .v-event-drag-bottom::after {
  display: block;
}
.v-current-time {
  height: 1px;
  background-color: red;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;
}

.v-current-time.first::after {
  content: "";
  position: absolute;
  background-color: red;
  width: 7px;
  height: 7px;
  border-radius: 3.5px;
  margin-top: -3px;
  margin-left: -3px;
}

.v-current-time .v-current-time-time {
  display: none;
}

.v-current-time .v-current-time-time.first .v-current-time-time {
  display: block;
  position: absolute;
  left: -60px;
  color: red;
  font-size: 10px;
  padding: 1px;
  background-color: white;
  width: 50px;
  height: 20px;
  text-align: right;
  top: -9px;
}
</style>